import axios from 'axios';


export const actionTypes = (typeName, prefix = null) => {
  const name = prefix ? prefix + '_' + typeName : typeName;
  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
    },
  };
};


export const instance = axios.create({
  baseURL: `${window.location.origin}/${process.env.REACT_APP_BACKEND_FLOWABLE_CONTEXT_PATH}`,
  withCredentials: true,
});

export const documentKeys = payload => {
   const additionalDocumentKeysList = [
  'auditorEvaluation',
  'objectionEvaluation'
  ];
  return Object.keys(payload).filter(
    v => v.startsWith('sup') || additionalDocumentKeysList.includes(v) );
}

export const carrierKeys = payload => {
  const additionalCarrierKeysList = [
    'additionalServices',
    'companyName',
    'legalSurname',
    'legalName',
    'legalFather',
    'birthDate',
    'legalAdt',
    'legalVat',
    'legalPhone',
    'abiStreet',
    'abiTk',
    'abiPerfecture',
    'abiDistrict',
    'mainKAD',
    'mainKADDescription',
    'legalPhoneMobile',
    'legalEmail',
    'legalEmailValidated',
    'companyLegalType',
    'invMob',
    'website',
    'invMail',
    'ownerStatus',
    'residence',
    'ownerSurname',
    'ownerFirstname',
    'ownerVat',
    'buildStreetBuilding',
    'buildTkBuilding',
    'buildPerfectureBuilding',
    'abiDistrictBuilding',
    'powerNumberBuilding',
    'contactPersonFlag',
    'contactSurname',
    'contactName',
    'contactVat',
    'contactPhone',
    'contactEmail',
    'powerSupply',
    'powerSupplyPrivate',
    'powerSupplyPublic',
    'ameaMember',
    'legalChildren',
    'individualIncome',
    'legalIncome',
    'carrierUsers',
    'regionalUnitiesActivityArea',
    'municipalitiesActivityArea',
    'selectedActivityAreasCodes',
    'marketing',
    'applicationReturned',
    'objCommentBen',
    'id',
    'additionalKAD',
    'isForeignSupplier',
  ];
  return Object.keys(payload).filter(
    v => v.startsWith('abi') || additionalCarrierKeysList.includes(v)
  );
};

export const bankKeys = payload => {
  const additionalBankKeysList = [
    'bnkBank',
    'swiftBIC',
    'beneficiaryIban',
    'ibanValidation',
    'requiresIbanUpdate'
  ]
  return Object.keys(payload).filter(
    v => additionalBankKeysList.includes(v)
  );
};

export const auditorKeys = payload => {
  const additionalAuditorKeysList = [
    'auditorComment',
    'returnAuditorMessage',
  ]
  return Object.keys(payload).filter(
      v => additionalAuditorKeysList.includes(v)
  );
};

export const objectionKeys = payload => {
  const additionalObjectionKeysList = [
    'objectionCommitteeComment',
  ]
  return Object.keys(payload).filter(
      v => additionalObjectionKeysList.includes(v)
  );
};

export const kadBranchesKeys = payload => {
  const additionalkadBranchesKeysList = [
    'getAllKadBranchesReturn',
    'isDirectSupplier',
    'isIndirectSupplier',
    'isEquipmentVoucher',
    'isServiceVoucher',
  ]
  return Object.keys(payload).filter(
    v =>  additionalkadBranchesKeysList.includes(v)
  );
};

export const AssetKeys = payload =>
  Object.keys(payload).filter(
    v =>
      v.startsWith('businessPlanAssets') || 
      v.startsWith('InvestmentTotalAmountTable') || 
      v.startsWith('businessPlanCoverage') ||
      v.startsWith('mainKads') ||
      v.startsWith('addKads')
  );

export const termsKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('term')
  );

export const xedmKeys = payload =>
  Object.keys(payload).filter(
    v => v.startsWith('details')
  );

export const objectionInvestorKeys = payload => {
  return Object.keys(payload.variables).filter(v => v.startsWith('objInv'));
};


export const projectPlanInfoKeys = payload => {
  const additionalProjectPlanInfoKeysList = ['projectPlans', 'messages', 'timestamp'];
  return Object.keys(payload).filter(v =>
    additionalProjectPlanInfoKeysList.includes(v)
  );
};



